import axios from "axios";
import {
  FETCH_PERIODOS_REQUEST,
  FETCH_PERIODOS_SUCCESS,
  FETCH_PERIODOS_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionPeriodosGet = () => async (dispatch) => {
  dispatch({ type: FETCH_PERIODOS_REQUEST });
  try {
    const res = await api.get("/facturacion/periodos", { headers: authHeader() });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_PERIODOS_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar periodos";
    dispatch({ type: FETCH_PERIODOS_FAILURE, payload: { error: msg } });
  }
};

export const apiFacturacionInstance = api;
export { authHeader as authHeaderFacturacion };
